// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__19dpu","gfeWrapper":"CalendarEvent_gfeWrapper__1s_8p"};